<template>
    <vx-box class="p-4 flex items-center gap-2">
        <div class="grow">
            <div class="flex items-center line-clamp-1 font-bold gap-2">
                {{ props.definition.name }}
            </div>
            <div v-if="props.definition.classification_steering" class="text-sm text-slate-500 line-clamp-2">
                {{ props.definition.classification_steering }}
            </div>
            <div v-if="props.definition.message_steering" class="text-xs text-slate-500 line-clamp-2">
                {{ props.definition.message_steering }}
            </div>
        </div>

        <vx-button
            data-test="delete-btn"
            outline
            color="muted"
            :disabled="props.disabled"
            @click="emit('delete', props.definition)"
        >
            <font-awesome-icon widthAuto :icon="faTrash"></font-awesome-icon>
        </vx-button>
        <vx-button
            data-test="edit-btn"
            outline
            color="muted"
            :disabled="props.disabled"
            @click="emit('edit', props.definition)"
        >
            Edit <font-awesome-icon widthAuto :icon="faFilePen"></font-awesome-icon>
        </vx-button>
    </vx-box>
</template>

<script lang="ts" setup>
import { faFilePen, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxBox, VxButton } from '@voxie/frontend-components';
import type { MembershipStatusDefinitionType } from '~/services/membershipStatusDefinitions/membershipStatusDefinitionsClient.types';

const props = defineProps<{
    definition: MembershipStatusDefinitionType;
    disabled?: boolean;
}>();

const emit = defineEmits<{
    edit: [definition: MembershipStatusDefinitionType];
    delete: [definition: MembershipStatusDefinitionType];
}>();
</script>
